"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = warn;
exports.warnIf = warnIf;
var warnPrefix = 'PsValidation debugger: ';

function warn(message) {
  if (!process.env.JEST_WORKER_ID) {
    window.console.warn(warnPrefix + message);
  }

  return true;
}

function warnIf(condition, message) {
  if (condition) {
    if (!process.env.JEST_WORKER_ID) {
      window.console.warn(warnPrefix + message);
    }

    return true;
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@primitivesocial/ps-validation/dist/utils/Console.js
// module id = p1Ki
// module chunks = 0 1